import script from "./CustomerCases.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerCases.vue?vue&type=script&setup=true&lang=js"

import "./CustomerCases.vue?vue&type=style&index=0&id=7a3b27d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a3b27d4"]])

export default __exports__